// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/user","layout":false,"id":"1"},"2":{"name":"login","path":"/user/login","parentId":"1","id":"2"},"3":{"path":"/login/callback","layout":false,"id":"3"},"4":{"path":"/projects","name":"projects","icon":"smile","parentId":"ant-design-pro-layout","id":"4"},"5":{"path":"/","redirect":"/projects","parentId":"ant-design-pro-layout","id":"5"},"6":{"path":"/projectDetails/:id","parentId":"ant-design-pro-layout","id":"6"},"7":{"path":"/workspaceDetails/:id","parentId":"ant-design-pro-layout","id":"7"},"8":{"layout":false,"path":"./*","id":"8"},"ant-design-pro-layout":{"id":"ant-design-pro-layout","path":"/","isLayout":true}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import('./EmptyRoute')),
'2': React.lazy(() => import(/* webpackChunkName: "p__user__login__index" */'@/pages/user/login/index.tsx')),
'3': React.lazy(() => import(/* webpackChunkName: "p__user__login__callback" */'@/pages/user/login/callback.tsx')),
'4': React.lazy(() => import(/* webpackChunkName: "p__Projects" */'@/pages/Projects.tsx')),
'5': React.lazy(() => import('./EmptyRoute')),
'6': React.lazy(() => import(/* webpackChunkName: "p__ProjectDetails" */'@/pages/ProjectDetails.tsx')),
'7': React.lazy(() => import(/* webpackChunkName: "p__Workspace" */'@/pages/Workspace.tsx')),
'8': React.lazy(() => import(/* webpackChunkName: "p__404" */'@/pages/404.tsx')),
'ant-design-pro-layout': React.lazy(() => import(/* webpackChunkName: "t__plugin-layout__Layout" */'/home/jose/Development/Speedcargo/Fedex/cargomind-ui/src/.umi-production/plugin-layout/Layout.tsx')),
},
  };
}
